<template>
  <v-card tile flat class="my-5">
    <v-card-text class="pa-0">
      <v-row no-gutters>
        <v-col cols="2">
          <div class="bg-kiri"></div>
        </v-col>
        <v-col cols="10" class="pa-5">
          <h1 class="headline info--text"> 1. Verval Data </h1>
          <h3 class="black--text font-weight-regular">Verifikasi dan Validasi Data Kepala Sekolah (Pra-Pleno)</h3>
          <p class="body-2 mt-4 black--text">
            Anda diharuskan untuk melakukan verval / pengecekan terhadap semua data Kepala Sekolah (Nama Lengkap, No
            UKG, dan semua Informasi Sekolah). Pastikan semua data sudah diverval dan sesuai dengan keadaan yang
            sekarang.
            <strong>
              Data yang tampil di bawah ini, bersumber dari data DAPODIK. Jika memerlukan perubahan data, pastikan sudah
              diubah dan sudah ada serta tersimpan di DAPODIK
            </strong>
          </p>
          <v-alert
            v-if="!isPemantauBorang"
            colored-border
            class="pa-2 my-2 bg-notif"
            color="warning"
            style="border-width: 0 !important;"
          >
            <v-row no-gutters style="flex-wrap: nowrap">
              <v-col cols="1" class="flex-grow-1 flex-shrink-0 my-auto" style="max-width: 50px">
                <v-icon class="mx-2 orange--text">mdi-alert</v-icon>
              </v-col>
              <v-col cols="11" class="flex-grow-1 flex-shrink-0 my-auto">
                <p class="body-2 mb-0 black--text">
                  Anda harus memastikan bahwa semua data Kepala Sekolah sudah diverval dan tidak terdapat data yang
                  berstatus <span class="font-weight-medium">Proses Perbaikan</span>. Anda dapat melanjutkan ke tahap
                  selanjutnya dengan <strong>klik Tombol Konfirmasi Data</strong> berikut.
                </p>
              </v-col>
            </v-row>
            <v-row no-gutters style="flex-wrap: nowrap">
              <v-col cols="1" class="flex-grow-1 flex-shrink-0 my-auto" style="min-width: 40px; max-width: 50px">
                &nbsp;
              </v-col>
              <v-col cols="11" class="flex-grow-1 flex-shrink-0 my-auto">
                <v-btn
                  class="mt-2 white--text"
                  color="orange"
                  small
                  style="text-transform: capitalize"
                  depressed
                  :disabled="+pspPeringkat.is_lengkap_verval !== 1 || !$allow('psp-peringkat-kandidat.selesai')"
                  @click="onConfirm"
                >
                  <v-icon left dark>
                    mdi-check
                  </v-icon>
                  Konfirmasi Data
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'verval-content',
  computed: {
    ...mapState('peringkat', {
      pspPeringkat: (state) => state.psp_peringkat || {},
      tutupKonfirmasi: (state) => state.tutup_konfirmasi || '',
    }),

    ...mapState('preferensi', {
      groups: (state) => state?.data?.groups ?? {},
    }),

    isPemantauBorang() {
      const kGroups = this.groups && Object.keys(this.groups);
      return kGroups.includes('255');
    },
  },

  methods: {
    ...mapActions('peringkat', ['detail', 'save']),

    async onConfirm() {
      if (this.tutupKonfirmasi) {
        this.$error(this.tutupKonfirmasi);
        return;
      }

      const { data } = await this.detail({ action: 'kandidat', id: 'statistik' });

      const msg = [
        '<p class="black--text font-weight-medium" style="font-size: 18px">Apakah Anda yakin Bahwa semua data Kepala Sekolah yang tersedia sudah diverval ?</p>',
        '<h3 class="black--text">Rangkuman Proses Verval Data</h3>',
        '<div class="body-2 black--text">Berikut ini rangkuman dari proses verval yang Anda lakukan</div>',
        '<ul class="body-2 black--text">',
        `<li><strong class="green--text">Sudah sesuai: </strong> <span class="subtitle-2">${data['2'] ||
          0}</span> sekolah</li>`,
        `<li><strong class="red--text">Diskualifikasi: </strong> <span class="subtitle-2">${data['3'] ||
          0}</span> sekolah</li>`,
        `<li><strong class="orange--text">Proses perbaikan: </strong> <span class="subtitle-2">${data['4'] ||
          0}</span> sekolah</li>`,
        '</ul>',
        '<p class="body-2 black--text mt-4 text-justify">Proses ini akan menkonfirmasikan bahwa semua data Kepala Sekolah sudah benar dan akan dilanjutkan ',
        'pada tahap Borang Peringkat Kepala Sekolah <span class="red--text">(data Kepala Sekolah akan dikunci dan tidak dapat ',
        'diubah lagi pada sistem)</span>.</p>',
        '<p class="body-2 black--text text-justify">Jika Anda merasa ingin melakukan perbaikan kembali, atau merubah proses verval, silakan klik <strong>TIDAK</strong> jika tetap ingin ke langkah selanjutnya silakan klik <strong>LANJUTKAN</strong></p>',
      ].join('');

      this.$confirm(msg, 'Konfirmasi Data Kepala Sekolah', {
        lblConfirmButton: 'Lanjutkan',
        typeConfirmBgButton: true,
        contentDivider: true,
      }).then(() => {
        this.save({ action: 'kandidat', type: 'selesai' }).then(() => {
          this.$success('Data berhasil disimpan');
          this.$emit('reload');
        });
      });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
